import React from 'react';
import { FormattedHTMLMessage, injectIntl, InjectedIntl } from 'react-intl';
import {
    FormFieldComponentProps,
    setRef,
    VerificationService,
    StudentPersonalInfoViewModel,
} from '@sheerid/jslib';
import NumberFormat from 'react-number-format';
import { getQueryParamsByName } from '../../lib/utils/browser';

interface PassedProps {
    explanation?: string | JSX.Element;
    verificationService: VerificationService;
}

const BirthDate = ({
    value,
    onChange,
    explanation,
    intl = undefined,
    isErrored = false,
    placeholder = '',
    verificationService,
}: FormFieldComponentProps & PassedProps) => {
    const formatAndUpdateDate = (date: string) => {
        const dateParts = date.split('/');
        const year = dateParts[0];
        const month = dateParts[1];
        const day = dateParts[2];
        onChange(`${year}-${month}-${day}`);
    };
    const viewModel = verificationService.viewModel as StudentPersonalInfoViewModel;
    const locale = viewModel.localeChoice.value || getQueryParamsByName('locale');

    return (
        <div className="sid-field sid-birth-date">
            <div className="sid-l-space-top-md" />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control*/}
            <label htmlFor="sid-birth-date">
                <div className={`sid-field__label sid-field__label--required sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                    <FormattedHTMLMessage
                        id="birthDate"
                        defaultMessage="Date of birth"
                    />
                </div>
            </label>

            <NumberFormat
                id="sid-birth-date"
                className={`sid-text-input sid-l-full-width ${isErrored ? 'sid-text-input--error' : ''}`}
                value={value}
                placeholder={placeholder || (intl as InjectedIntl).formatMessage({ id: 'birthDatePlaceholder', defaultMessage: 'yyyy/mm/dd' })}
                format="####/##/##"
                mask={
                    (locale === 'fr-CA') ? ['A', 'A', 'A', 'A', 'M', 'M', 'J', 'J'] : ['Y', 'Y', 'Y', 'Y', 'M', 'M', 'D', 'D']
                }
                getInputRef={(input: HTMLInputElement) => {
                    setRef('birthDate', input);
                    setRef('birthDateYear', input);
                }}
                onChange={(e: any) => formatAndUpdateDate(e.target.value)}
                type="tel"
                required
            />

            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidBirthDate"
                            defaultMessage="Invalid birth date"
                        />
                    </div>
                ) : null
            }

            <div className="sid-field__label-explanation">
                {
                    explanation || (
                        <FormattedHTMLMessage
                            id="verificationPurposesOnly"
                            defaultMessage="Used for verification purposes only"
                        />
                    )
                }
            </div>
        </div>
    );
};

export const BirthDateComponent = injectIntl(BirthDate);
